import { AnyAction, isType } from 'typescript-fsa';
import { EventHandlerConfiguration } from '../../../services/account';
import { eventHandlerConfigSet, eventHandlerConfigSetMissing } from './actions';

interface ServerEventHandlerState {
    handler: EventHandlerConfiguration[];
    missing: EventHandlerConfiguration[];
}

const initialServerEventHandlerState: ServerEventHandlerState = {
    handler: [],
    missing: []
};

export interface EventHandlerConfigState {
    [server: string]: ServerEventHandlerState;
}

const initialEventHandlerConfigState: EventHandlerConfigState = {};

export function eventHandlerConfigReducer(
    state: EventHandlerConfigState = initialEventHandlerConfigState,
    action: AnyAction
): EventHandlerConfigState {
    if (isType(action, eventHandlerConfigSet)) {
        const serverState = { ...(state[action.payload.server] || initialServerEventHandlerState) };
        serverState.handler = action.payload.config;
        return { ...state, [action.payload.server]: serverState };
    } else if (isType(action, eventHandlerConfigSetMissing)) {
        const serverState = { ...(state[action.payload.server] || initialServerEventHandlerState) };
        serverState.missing = action.payload.config;
        return { ...state, [action.payload.server]: serverState };
    }

    return state;
}
